import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/api/client";
import TopBar from "@/components/TopBar";
import { ChevronLeft, ShoppingBag, Mic } from "lucide-react";

const STATUS_LABELS = {
  pending: "بانتظار التأكيد", preparing: "قيد التحضير", ready: "جاهز",
  assigned: "تم تعيين سائق", picked_up: "في الطريق", delivered: "تم التسليم", cancelled: "ملغي"
};

const STATUS_COLORS = {
  pending: "bg-yellow-100 text-yellow-700",
  preparing: "bg-blue-100 text-blue-700",
  ready: "bg-blue-100 text-blue-700",
  assigned: "bg-purple-100 text-purple-700",
  picked_up: "bg-primary-light text-primary-brand",
  delivered: "bg-green-100 text-green-700",
  cancelled: "bg-red-100 text-red-700",
};

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/orders/mine");
        setOrders(data);
      } finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-[var(--background)]">
      <TopBar/>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-6">
        <h1 className="text-3xl font-black mb-6" style={{fontFamily:'Cairo'}}>طلباتي</h1>

        {loading ? (
          <div className="flex flex-col gap-3">{[...Array(3)].map((_,i)=><div key={i} className="h-28 rounded-2xl shimmer"/>)}</div>
        ) : orders.length === 0 ? (
          <div className="bg-white rounded-3xl p-12 text-center talabya-shadow-soft">
            <ShoppingBag size={40} className="mx-auto text-[var(--text-secondary)] mb-3"/>
            <h2 className="text-xl font-bold mb-2" style={{fontFamily:'Cairo'}}>لا يوجد طلبات بعد</h2>
            <Link to="/" className="inline-block mt-3 px-5 py-2.5 rounded-xl bg-primary-brand text-white font-bold" data-testid="orders-browse">ابدأ الطلب</Link>
          </div>
        ) : (
          <div className="flex flex-col gap-3">
            {orders.map((o) => (
              <Link to={`/track/${o.id}`} key={o.id} className="bg-white rounded-2xl p-4 talabya-shadow-soft border border-[var(--border)] hover:border-primary-brand transition flex justify-between items-center relative" data-testid={`order-row-${o.id}`}>
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className="font-black" style={{fontFamily:'Cairo'}}>{o.code}</span>
                    <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${STATUS_COLORS[o.status]}`}>{STATUS_LABELS[o.status]}</span>
                    {o.unread_voice_count > 0 && (
                      <span
                        className="inline-flex items-center gap-1 text-[10px] font-black px-2 py-0.5 rounded-full bg-[#E05A3D] text-white animate-pulse"
                        title="رسائل صوتية غير مقروءة من السائق"
                        data-testid={`voice-badge-${o.id}`}
                      >
                        <Mic size={10}/> {o.unread_voice_count} صوتية جديدة
                      </span>
                    )}
                  </div>
                  <div className="text-xs text-[var(--text-secondary)]">
                    {o.items.length} صنف · {o.fulfillment === "delivery" ? "توصيل" : "استلام"} · {new Date(o.created_at).toLocaleString("ar-LY", { dateStyle: "short", timeStyle: "short" })}
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <div className="font-black text-primary-brand" style={{fontFamily:'Cairo'}}>{o.total.toFixed(2)} د.ل</div>
                  <ChevronLeft size={18} className="text-[var(--text-secondary)]"/>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
